export default {
  ENTERPRISE: 1,
  CORPORATE: 2,
  BUSINESS2: 3,
  BUSINESS1: 4,
  PERSONAL: 5,
  FREE: 6,
  ENTERPRISEPLUS: 7,
  STARTUP: 8,
  SMALLOFFICE: 9,
  PROFESSIONAL: 10,
  BUSINESS: 11,
  ENTERPRISECUSTOM: 12,
  OFFICE: 13,
  BUSINESSPLAN: 14,
  SMALLOFFICE010617: 15,
  PROFESSION010617: 16,
  BUSINESS010617: 17,
  PERUSER_FREE: 18,
  PERUSER_PRO2017: 19,
  PERUSER_ENTERPRISE: 20,
  PERUSER_PRO: 21,
  PERUSER_PREMIUM: 22,
  PERUSER_CORPORATE: 34,
  PERUSER_PRO_2020_07: 41,
  PERUSER_PREMIUM_2020_07: 42,
  PERUSER_TWONE_2020: 43,
  PERUSER_DELIVER_2021: 47,
  PERUSER_GROW_2021: 48,
  PERUSER_SCALE_2021: 51,
  PERUSER_DELIVER_2022: 64,
  PERUSER_GROW_2022: 65,
  PERUSER_SCALE_2022: 66,
  STARTER: 67,
  PERUSER_ENTERPRISE_2023: 68,
  PERUSER_GROW_2023: 69,
};
